<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { watch } from 'vue'
import { CurrencyDisplay, useCurrencyInput } from 'vue-currency-input'

// v-model macro
const model = defineModel()
defineEmits(['change'])

const props = defineProps<{
  clearable?: boolean
  minValue?: number
  maxValue?: number
  percentage?: boolean
  precision?: number
  prefix?: string
  allowNegative?: boolean
}>()

const { inputRef, formattedValue, setValue } = useCurrencyInput({
  currency: 'USD',
  currencyDisplay: CurrencyDisplay.hidden,
  valueRange: { min: props.percentage ? -100 : props.minValue, max: props.percentage ? 100 : props.maxValue },
  precision: props.precision ?? 2,
})

/**
 * Handles Element Plus input's "clear" button click.
 * (Resets `vue-currency-input` value)
 */
const handleClear = () => {
  setValue(null)
}

// Allow for form reset.
watch(
  () => model.value,
  (value: any) => {
    setValue(value)
  }
)
</script>

<template>
  <el-input
    ref="inputRef"
    v-model="formattedValue"
    placeholder="0.00"
    :clearable="clearable"
    :inputmode="allowNegative ? 'text' : 'decimal'"
    @clear="handleClear"
  >
    <template #prefix>
      <template v-if="prefix">
        {{ prefix }}
      </template>
      <template v-else-if="percentage">
        <Icon icon="material-symbols:percent" :height="20" :inline="true" />
      </template>
      <template v-else>
        <Icon icon="material-symbols:attach-money-rounded" :height="20" :inline="true" />
      </template>
    </template>
  </el-input>
</template>
